import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import { RegionsManager } from './RegionsManager'
import { SubregionsManager } from './SubregionsManager'
import { TechniquesManager } from './TechniquesManager'
import { LateralitiesAndPurposesManager } from './LateralitiesAndPurposesManager'

export const VocabularyTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return (
    <Box sx={{ p: 1.5 }}>
      <Tabs 
        value={activeTab} 
        onChange={handleTabChange} 
        variant="scrollable" 
        scrollButtons="auto"
        sx={{
          minHeight: 32,
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            minHeight: 32,
            py: 0.5,
            px: 1.5,
            fontSize: '0.75rem',
            textTransform: 'none'
          }
        }}
      >
        <Tab label="Regiuni Anatomice" />
        <Tab label="Subregiuni Anatomice" />
        <Tab label="Tehnici" />
        <Tab label="Lateralități & Purpose-uri" />
      </Tabs>

      <Box sx={{ mt: 1.5 }}>
        {activeTab === 0 && <RegionsManager />}
        {activeTab === 1 && <SubregionsManager />}
        {activeTab === 2 && <TechniquesManager />}
        {activeTab === 3 && <LateralitiesAndPurposesManager />}
      </Box>
    </Box>
  )
}

